/* eslint-disable no-unsafe-finally */
/* eslint-disable camelcase */

import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import { components, api } from '@seaoil/component-lib';
import { LayoutWithNav } from '../components/Layout';

const { Auth } = components;
const { mySEAOIL } = api;
const { Text } = Typography;

function ViewFile() {
  const [message, setMessage] = useState('');

  const onload = async () => {
    try {
      setMessage('Trying to access the file...');
      const s3_file_path = decodeURIComponent(window.location.href.split('filepath=')[1]);

      setMessage('Getting temporary file link...');
      const result = await mySEAOIL.file.download({ s3_file_path }).send();

      setMessage('The file was successfully retrieved');
      window.location.href = result.download_url;
    } catch (e) {
      setMessage(`Unable to retrieve the file. Send this link: ${window.location.href} to supportdesk@seaoil.com.ph`);
    }
  };

  useEffect(() => {
    onload();
  }, []);

  return (
    <Auth.PrivateComponent redirect="/login">
      <LayoutWithNav>
        <Text>{message}</Text>
      </LayoutWithNav>
    </Auth.PrivateComponent>
  );
}

export default ViewFile;
